import React, { Component }     from "react";
import { Button, MenuItem, Modal, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon }          from '@fortawesome/react-fontawesome'
import LoaderButton                 from "../../components/LoaderButton";
import { Colors }                   from "../../utils/Colors";
import { invokeGetAssessmentDetail} from "../../utils/AwsInvoke";
import { XYPlot,
          Crosshair,
          DiscreteColorLegend,
          FlexibleWidthXYPlot,
          HorizontalGridLines,
          LineSeries,
          LineMarkSeries,
          VerticalGridLines,
          SearchableDiscreteColorLegend,
          XAxis,
          YAxis }        from 'react-vis';

const axisProps = {
    tickSizeInner: 0,
    style: {line: {stroke: '#939393', strokeWidth: '1px'}}
};

const deadlift_color   = "#c22a2a";
const backsquat_color  = "#6621c4";
const frontsquat_color = "#2e78e7";
const hexbar_color     = "#bf56fc";
const bench_color      = "#56e7fc";
const bentover_color   = "#fc9856";
const clean_color      = "#fc56a0"
const overhead_color   = "#c91bde";
const snatch_color     = "#1bc9de";
const jerk_color       = "#dea91b";
const pull_up_color    = "#3da211";

const STRENGTH_LEGEND = [
    {title: 'All',  data: "all_data", color: "#000", strokeWidth: 14},
    {title: 'Deadlift',  data: "deadlift_data", color: deadlift_color, strokeWidth: 14},
    {title: 'Back Squat', data: "backsquat_data", color: backsquat_color, strokeWidth: 14 },
    {title: 'Front Squat', data: "front_squat_data", color: frontsquat_color, strokeWidth: 14 },
    {title: 'Hex Bar Deadlift', data: "hex_bar_deadlift_data", color: hexbar_color, strokeWidth: 14 },
    {title: 'Bench Press', data: "bench_press_data", color: bench_color, strokeWidth: 14 },
    {title: 'Bent Over Row', data: "bent_over_row_data", color: bentover_color, strokeWidth: 14 },
    {title: 'Clean', data: "clean_data", color: clean_color, strokeWidth: 14 },
    {title: 'Overhead Squat', data: "overhead_squat_data", color: overhead_color, strokeWidth: 14 },
    {title: 'Snatch', data: "snatch_data", color: snatch_color, strokeWidth: 14 },
    {title: 'Jerk', data: "jerk_data", color: jerk_color, strokeWidth: 14 },
    {title: 'Pull-up', data: "pull_up_data", color: pull_up_color, strokeWidth: 14 }
];

var deadlift_data        = [];
var backsquat_data       = [];
var front_squat_data     = [];
var hex_bar_deadlift_data= [];
var bench_press_data     = [];
var bent_over_row_data   = [];
var clean_data           = [];
var overhead_squat_data  = [];
var snatch_data          = [];
var jerk_data            = [];
var pull_up_data         = [];

var legend1_title = "Deadlift";
var legend2_title = "Back Squat";
var legend3_title = "Front Squat";
var legend4_title = "Hex Bar Deadlift";
var legend5_title = "Bench Press";
var legend6_title = "Bent Over Row";
var legend7_title = "Clean";
var legend8_title = "Overhead Squat";
var legend9_title = "Snatch";
var legend10_title = "Jerk";
var legend11_title = "Pull-up";

export default class AssessStrength extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            title:     "Strength Assessment",
            max_y_val: 0,
            min_y_val: 0,
            all_data: true,
            crosshairPreValues:      [],
        }
    }

    componentDidMount() {
        try {
            this.getClientData();
        } catch (e) {
            alert(e);
        }
    }

    resetDataVals () {
        deadlift_data        = [];
        backsquat_data       = [];
        front_squat_data     = [];
        hex_bar_deadlift_data= [];
        bench_press_data     = [];
        bent_over_row_data   = [];
        clean_data           = [];
        overhead_squat_data  = [];
        snatch_data          = [];
        jerk_data            = [];
        pull_up_data         = [];
    }

    getClientData = async () => {
        this.setState({
            loadingData: "Loading member data ... "
        })

        const results  = this.props.resultsStrength;//await invokeGetClientAssessmentStrengthReport(client_id);

        var asessInbodyChartData = [];
        var max_yaxis_val        = [];

        // Reset all vals in case someone clicks "All" multiple times; we don't want multiple duplicate vals
        this.resetDataVals();

        if(results) {
            var data            = results.data.strength;
            var ctr = 0;
            var max_array = [];
            ////  BEGIN: BUILD OUT GRAPH DATA  ////
            for(var key in data) {
                var deadlift            = data[key].deadlift;
                var back_squat          = data[key].back_squat
                var front_squat         = data[key].front_squat;
                var hex_bar_deadlift    = data[key].hex_bar_deadlift;
                var bench_press         = data[key].bench_press
                var bent_over_row       = data[key].bent_over_row
                var clean               = data[key].clean;
                var overhead_squat      = data[key].overhead_squat;
                var snatch              = data[key].snatch;
                var jerk                = data[key].jerk;
                var pull_up             = data[key].pull_up;
                var date_created        = data[key].date_created;
                var date                = (new Date(date_created)).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })

                pull_up_data.push({"x": date, "y": pull_up});// test_arr[ctr++]});
                deadlift_data.push({"x": date, "y": deadlift});
                backsquat_data.push({"x": date, "y": back_squat});
                front_squat_data.push({"x": date, "y": front_squat});
                hex_bar_deadlift_data.push({"x": date, "y": hex_bar_deadlift});
                bench_press_data.push({"x": date, "y": bench_press});
                bent_over_row_data.push({"x": date, "y": bent_over_row});
                clean_data.push({"x": date, "y": clean});
                overhead_squat_data.push({"x": date, "y": overhead_squat});
                snatch_data.push({"x": date, "y": snatch});
                jerk_data.push({"x": date, "y": jerk});

                // Get Max Value of All Data points and then filter out the highest value to use in the y-axis //
                max_array.push(deadlift, back_squat, front_squat, hex_bar_deadlift, bench_press, bent_over_row, clean, overhead_squat, snatch, jerk, pull_up)
            }

            var max_y_val = Math.max(...max_array) + 35;

            this.setState({
                report_data: data.length,
                all_data: true,
                pull_up_data: pull_up_data,
                deadlift_data: deadlift_data,
                backsquat_data: backsquat_data,
                front_squat_data: front_squat_data,
                hex_bar_deadlift_data: hex_bar_deadlift_data,
                bench_press_data: bench_press_data,
                bent_over_row_data: bent_over_row_data,
                clean_data: clean_data,
                overhead_squat_data: overhead_squat_data,
                snatch_data: snatch_data,
                jerk_data: jerk_data,
                max_y_val: max_y_val,
                min_y_val: 0 // reset min y val
            })
        } else {
            //this.msgDataLoaded();
        }
    }

    onMouseLeavePreWorkout = () =>{
        this.setState({crosshairPreValues: []});
    }

    ////   Tooltip Hover   ////
    onNearestXPreWorkout = (value, {index}) => {
        var x   = deadlift_data[index].y;
        var x2  = deadlift_data[index].x;
        var y1  = backsquat_data[index].y;
        var y2  = front_squat_data[index].y;
        var y3  = hex_bar_deadlift_data[index].y;
        var y4  = bench_press_data[index].y;
        var y5  = bent_over_row_data[index].y;
        var y6  = clean_data[index].y;
        var y7  = overhead_squat_data[index].y;
        var y8  = snatch_data[index].y;
        var y9  = jerk_data[index].y;
        var y10 = pull_up_data[index].y;

        this.setState({
                        crosshairPreValues: [{x: x2, y: y1}],
                        crossHairX:  x,
                        crossHairY1: y1,
                        crossHairY2: y2,
                        crossHairY3: y3,
                        crossHairY4: y4,
                        crossHairY5: y5,
                        crossHairY6: y6,
                        crossHairY7: y7,
                        crossHairY8: y8,
                        crossHairY9: y9,
                        crossHairY10: y10,
                      });
    };

    getMaxYAxisVals (data) {
        var arr = []
        var data2 = eval(data); // get actual vals of array

        for(var key in data2)
            arr.push(data2[key].y);

        var max_y_val = Math.max(...arr) + 15;
        var min_y_val = Math.min(...arr) - 15;

        // Don't let min_y_val go below 0
        if(min_y_val < 0) min_y_val = 0;

        var maxMinObj = {};
        maxMinObj.max_y_val = max_y_val;
        maxMinObj.min_y_val = min_y_val;

        return maxMinObj;
    }

    handleLegendClick = item => {
        var data = item.data;
        var dataset;

        if(data === "all_data")
            this.setState({
                all_data: false
            }, () => {
                this.getClientData();
            });
        else {
            if(data === "deadlift_data")              dataset = {"deadlift_data":deadlift_data};
            else if(data === "backsquat_data")        dataset = {"backsquat_data":backsquat_data};
            else if(data === "front_squat_data")      dataset = {"front_squat_data":front_squat_data};
            else if(data === "hex_bar_deadlift_data") dataset = {"hex_bar_deadlift_data": hex_bar_deadlift_data};
            else if(data === "bench_press_data")      dataset = {"bench_press_data": bench_press_data};
            else if(data === "bent_over_row_data")    dataset = {"bent_over_row_data": bent_over_row_data};
            else if(data === "clean_data")            dataset = {"clean_data": clean_data};
            else if(data === "overhead_squat_data")   dataset = {"overhead_squat_data": overhead_squat_data};
            else if(data === "snatch_data")           dataset = {"snatch_data": snatch_data};
            else if(data === "jerk_data")             dataset = {"jerk_data": jerk_data};
            else if(data === "pull_up_data")          dataset = {"pull_up_data": pull_up_data};

            var maxMinObj = this.getMaxYAxisVals(data);
            var max_y_val = maxMinObj.max_y_val;
            var min_y_val = maxMinObj.min_y_val;

            // Clear out all data since we're fiultering out datasets
            this.setState({
                all_data: false,
                current_dataset: data,
                deadlift_data: [],
                backsquat_data: [],
                front_squat_data: [],
                hex_bar_deadlift_data: [],
                bench_press_data: [],
                bent_over_row_data: [],
                clean_data: [],
                overhead_squat_data: [],
                snatch_data: [],
                jerk_data: [],
                pull_up_data: [],
                max_y_val: max_y_val,
                min_y_val: min_y_val
            }, function (){
                this.setState(dataset);
            })
        }

        //const {items} = this.state;
        //item.disabled = !item.disabled;
    };

    getAllTooltip () {
        return <span>
                    <span style={{display:"inline-block", verticalAlign:"top", width: "50%"}}>
                        <span style={{display: "block",fontSize:16}}>{ legend1_title }: {this.state.crossHairX} lbs.</span>
                        <span style={{display: "block",fontSize:16}}>{ legend2_title }: {this.state.crossHairY1} lbs.</span>
                        <span style={{display: "block",fontSize:16}}>{ legend3_title }: {this.state.crossHairY2} lbs.</span>
                        <span style={{display: "block",fontSize:16}}>{ legend4_title }: {this.state.crossHairY3} lbs.</span>
                        <span style={{display: "block",fontSize:16}}>{ legend5_title }: {this.state.crossHairY4} lbs.</span>
                        <span style={{display: "block",fontSize:16}}>{ legend6_title }: {this.state.crossHairY5} lbs.</span>
                    </span>
                    <span style={{display:"inline-block", width: "50%"}}>
                        <span style={{display: "block",fontSize:16}}>{ legend7_title }: {this.state.crossHairY6} lbs.</span>
                        <span style={{display: "block",fontSize:16}}>{ legend8_title }: {this.state.crossHairY7} lbs.</span>
                        <span style={{display: "block",fontSize:16}}>{ legend9_title }: {this.state.crossHairY8} lbs.</span>
                        <span style={{display: "block",fontSize:16}}>{ legend10_title }: {this.state.crossHairY9} lbs.</span>
                        <span style={{display: "block",fontSize:16}}>{ legend11_title }: {this.state.crossHairY10} lbs.</span>
                    </span>
                </span>
    }

    // Show only 1 value in the tooltip hover //
    getSingleTooltip () {
        var dataset = this.state.current_dataset;
        var legend;
        var crosshair;
        if(dataset == "deadlift_data") {
            legend    = legend1_title;
            crosshair = this.state.crossHairX;
        } else if(dataset == "backsquat_data") {
            legend    = legend2_title;
            crosshair = this.state.crossHairY1;
        } else if(dataset == "front_squat_data") {
            legend    = legend3_title;
            crosshair = this.state.crossHairY2;
        } else if(dataset == "hex_bar_deadlift_data") {
            legend    = legend4_title;
            crosshair = this.state.crossHairY3;
        } else if(dataset == "bench_press_data") {
            legend    = legend5_title;
            crosshair = this.state.crossHairY4;
        } else if(dataset == "bent_over_row_data") {
            legend    = legend6_title;
            crosshair = this.state.crossHairY5;
        } else if(dataset == "clean_data") {
            legend    = legend7_title;
            crosshair = this.state.crossHairY6;
        } else if(dataset == "overhead_squat_data") {
            legend    = legend8_title;
            crosshair = this.state.crossHairY7;
        } else if(dataset == "snatch_data") {
            legend    = legend9_title;
            crosshair = this.state.crossHairY8;
        } else if(dataset == "jerk_data") {
            legend    = legend10_title;
            crosshair = this.state.crossHairY9;
        } else if(dataset == "pull_up_data") {
            legend    = legend11_title;
            crosshair = this.state.crossHairY10;
        }

        return <span>
                    <span style={{display:"inline-block", verticalAlign:"top", width: "100%"}}>
                        <span style={{display: "block",fontSize:16}}>{ legend }: { crosshair } lbs.</span>
                    </span>
                </span>
    }

    render() {
        var title     = this.state.title;
        var max_y_val = this.state.max_y_val;
        var min_y_val = this.state.min_y_val;
        var all_data  = this.state.all_data;
        var report_data  = this.state.report_data;
        var no_data_text;
        if(report_data === 0)  no_data_text  = <div style={{position:"relative", top: 75, padding: 15, fontSize:18}}>There is no assessment data.</div>

        var tooltip;
        var tooltip_width = 220;
        if(all_data) {
            tooltip_width = 400;
            tooltip       = this.getAllTooltip();
        } else {
            tooltip       = this.getSingleTooltip();
        }

        return (
            <div className="assessmentForm" style={{textAlign:"left"}}>
                <div className="iconAddExercise35pxVertSpacer"></div>
                <span style={{position:"relative", left:-10}}>
                        <div style={{fontSize:22, textAlign:"center"}}>
                            <FontAwesomeIcon icon="dumbbell" style={{fontSize: '1.4em', paddingRight: 8 }}/>
                            <span style={{position:"relative", top:-4}}>
                                { title }
                                { no_data_text }
                            </span>
                        </div>
                        <span style={{display:"inline-block",width:"100%", border:"0px solid #000"}}>

                                <FlexibleWidthXYPlot height       = {200}
                                                     xType        = "ordinal"
                                                     yDomain      = {[min_y_val, max_y_val]}
                                                     onMouseLeave = {this.onMouseLeavePreWorkout}
                                                     onMouseDown  = {() => {
                                                         //this.setState({showModalProgressDetail: true})
                                                        /*if (heldValue) {
                                                          this.setState({heldValue: false});
                                                          return;
                                                        }*/
                                                        //this.setState({heldValue: crosshairValues});
                                                      }}
                                                     >
                                  <VerticalGridLines />
                                  <HorizontalGridLines />

                                  <XAxis title="" {...axisProps}
                                         tickFormat={String}/>

                                  <YAxis title="Pounds" {...axisProps}
                                         //tickValues={[0,10,20,30,40,50,260]}
                                         tickFormat={String} />

                                  <LineMarkSeries data={this.state.deadlift_data}           size={2.5} color={deadlift_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.backsquat_data}          size={2.5} color={backsquat_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.front_squat_data}        size={2.5} color={frontsquat_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.hex_bar_deadlift_data}   size={2.5} color={hexbar_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.bench_press_data}        size={2.5} color={bench_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.bent_over_row_data}      size={2.5} color={bentover_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.clean_data}              size={2.5} color={clean_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.overhead_squat_data}     size={2.5} color={overhead_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.snatch_data}             size={2.5} color={snatch_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.jerk_data}               size={2.5} color={jerk_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.pull_up_data}            size={2.5} color={pull_up_color} onNearestX={this.onNearestXPreWorkout}/>

                                  <Crosshair values={this.state.crosshairPreValues} >
                                      <div style={{float: "left", background: 'black', borderRadius: 5, width: tooltip_width, maxWidth: tooltip_width, borderRadius:5, padding: 10, zIndex: 1000}}>
                                          <span style={{display:"inline-block", width:"100%", fontSize:18, textAlign:"center"}}>{ title }</span>
                                             <br/>
                                             { tooltip }
                                      </div>
                                  </Crosshair>

                                </FlexibleWidthXYPlot>
                                { /**********  LEGEND  ***********/ }
                                <div style={{float: "left",  zIndex: 10}}>
                                    <DiscreteColorLegend items={STRENGTH_LEGEND}
                                                         orientation='horizontal'
                                                         onItemClick={this.handleLegendClick}
                                                         style={{display: "inline-block", position:"relative", width:900, top:-7, left:35}}/>
                                </div>
                        </span>
                 </span>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/report/AssessStrength.js